
import { H4 } from '../../config/designSystem/typography';
import { SelectorList } from '../Selector/SelectorList';
import { View } from 'react-native';
import { isWeb } from '../../config/designSystem/Layout';
import { useStores } from '../../hooks/useStores';



interface ChangeLanguageProps {
    language: string,
    changeLanguage: (language: string) => void,
    width?: number
  }

export const LanguagePicker = ({language, changeLanguage, width }: ChangeLanguageProps) => {


  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.SETTINGS;

  const data = [];

  for (const language of rootStore?.language.list) {
    data.push({
      _id: language.key,
      label: language.name,
    });
  }





  return(<View style={{zIndex:2}}>
    <H4>
      {labels?.CHANGE_LANGUAGE}
    </H4>
    <SelectorList data={data} alignToCenter={true} selectedItem={language} onSelect={(id, idx) => {
      changeLanguage(id);
    }}
    width={width?width:undefined}/>
  </View>);
};
